var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-sm-12 col-xs-12" }, [
    _c(
      "div",
      {
        staticClass: "panel panel-default",
        on: { dblclick: _vm.toggleEditMode }
      },
      [
        _c("div", { staticClass: "panel-heading" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("translate")("Page overview")) +
              "\n        "
          )
        ]),
        _c("div", { staticClass: "panel-body" }, [
          _c(
            "div",
            { staticClass: "col-xs-12 ls-space margin top-5 bottom-5" },
            [
              _c("div", { staticClass: "col-12" }, [
                _vm._v(_vm._s(_vm._f("translate")("Title")))
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentTitle,
                    expression: "currentTitle"
                  }
                ],
                staticClass: "form-control group-title",
                attrs: { id: "groupTitle" },
                domProps: { value: _vm.currentTitle },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.currentTitle = $event.target.value
                  }
                }
              })
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "col-xs-12 ls-space margin top-5 bottom-5 scope-contains-ckeditor"
            },
            [
              _c("div", { staticClass: "ls-flex-row col-12" }, [
                _c("div", { staticClass: "ls-flex-item text-left" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm._f("translate")("Description")) +
                      "\n                    "
                  )
                ]),
                _c("div", { staticClass: "ls-flex-item text-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default btn-xs",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.sourceMode = !_vm.sourceMode
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-file-code-o" }),
                      _vm._v(_vm._s(_vm._f("translate")("Toggle source mode")))
                    ]
                  )
                ])
              ]),
              !_vm.sourceMode
                ? _c("lsckeditor", {
                    attrs: {
                      editor: _vm.editorDescriptionObject,
                      config: _vm.editorDescriptionConfig
                    },
                    model: {
                      value: _vm.currentQuestionGroupDescription,
                      callback: function($$v) {
                        _vm.currentQuestionGroupDescription = $$v
                      },
                      expression: "currentQuestionGroupDescription"
                    }
                  })
                : _c("aceeditor", {
                    attrs: {
                      showLangSelector: false,
                      thisId: "questionEditSource"
                    },
                    model: {
                      value: _vm.currentQuestionGroupDescription,
                      callback: function($$v) {
                        _vm.currentQuestionGroupDescription = $$v
                      },
                      expression: "currentQuestionGroupDescription"
                    }
                  })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-sm-6 col-xs-12 ls-space margin top-5 bottom-5"
            },
            [
              _c("div", { staticClass: "col-12" }, [
                _vm._v(_vm._s(_vm._f("translate")("Random Group")))
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentQuestionGroupRandomgroup,
                    expression: "currentQuestionGroupRandomgroup"
                  }
                ],
                staticClass: "form-control",
                domProps: { value: _vm.currentQuestionGroupRandomgroup },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.currentQuestionGroupRandomgroup = $event.target.value
                  }
                }
              })
            ]
          ),
          _c(
            "div",
            {
              staticClass: "col-sm-6 col-xs-12 ls-space margin top-5 bottom-5"
            },
            [
              _c("div", { staticClass: "col-12" }, [
                _vm._v(_vm._s(_vm._f("translate")("Condition")))
              ]),
              _c("div", { staticClass: "input-group" }, [
                _c("span", { staticClass: "input-group-addon" }, [_vm._v("{")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.currentRelevance,
                      expression: "currentRelevance"
                    }
                  ],
                  staticClass: "form-control",
                  domProps: { value: _vm.currentRelevance },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.currentRelevance = $event.target.value
                    }
                  }
                }),
                _c("span", { staticClass: "input-group-addon" }, [_vm._v("}")])
              ])
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }